import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <PageSEO
        title="首页"
        description="国产自拍技巧全攻略，从手机选购、构图布光到后期修图，手把手教你用国产设备拍出专业级自拍效果。无论是日常记录还是社交分享，掌握这些国产自拍核心技巧，让每一张照片都成为精彩瞬间。"
        keywords="国产自拍,国产自拍技巧,手机自拍教程,国产手机拍照,自拍构图技巧,自拍灯光布置,手机后期修图"
        canonicalUrl="https://www.selfie-guide.cn/"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '国产自拍完全指南',
          url: 'https://www.selfie-guide.cn/',
          description: '国产自拍技巧全攻略，从手机选购、构图布光到后期修图，手把手教你用国产设备拍出专业级自拍效果。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.selfie-guide.cn/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}